import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../node_modules/classnames/index.js';
import { styled, Alert, AlertTitle } from '@mui/material';
import { EventType } from '../../cinnamon-core/es/modules/notifications/constants.js';
import { createComponentSlot } from '../../modules/styling/theme.js';

var _excluded = ["event", "maxMessageLength", "onDismiss", "onClick", "className"];
var componentItem = createComponentSlot({
  name: "CinNotificationStack",
  slot: "Item"
});

var getAlertSeverity = function getAlertSeverity(eventType) {
  switch (eventType) {
    case EventType.Success:
      return "success";

    case EventType.Info:
      return "info";

    case EventType.Warning:
      return "warning";

    case EventType.Error:
      return "error";

    default:
      return undefined;
  }
};

var getDisplayTime = function getDisplayTime(creation) {
  var ageSeconds = Math.floor((Date.now() - creation) / 1000);
  var ageMinutes = Math.floor(ageSeconds / 60);

  if (ageMinutes < 1) {
    return "Just now";
  }

  return "".concat(ageMinutes, " minute").concat(ageMinutes > 1 ? "s" : "", " ago");
};

var NotificationStackItemBase = function NotificationStackItemBase(_ref) {
  var event = _ref.event,
      maxMessageLength = _ref.maxMessageLength,
      onDismiss = _ref.onDismiss,
      onClick = _ref.onClick,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var truncatedMessage = maxMessageLength !== undefined && event.message.length > maxMessageLength ? event.message.substring(0, maxMessageLength) + "..." : event.message;
  return /*#__PURE__*/React.createElement(Alert, _extends({
    severity: getAlertSeverity(event.type),
    onClose: onDismiss ? function (e) {
      e.stopPropagation();
      onDismiss(e);
    } : undefined,
    onClick: onClick
  }, props, {
    className: classnames(componentItem.className, className)
  }), /*#__PURE__*/React.createElement(AlertTitle, null, event.title || event.type, /*#__PURE__*/React.createElement("span", {
    className: "notification-time"
  }, getDisplayTime(event.creation))), truncatedMessage);
};
/**
 * Renders a single item in a stack of notifications
 */


NotificationStackItemBase.propTypes = {
  className: propTypes.string
};
var NotificationStackItem = styled(NotificationStackItemBase, _objectSpread2(_objectSpread2({}, componentItem.styledOptions), {}, {
  skipVariantsResolver: true
}))(function (_ref2) {
  var onClick = _ref2.onClick;
  return _objectSpread2(_objectSpread2({}, onClick && {
    cursor: "pointer"
  }), {}, {
    ".MuiAlert-message": {
      width: "100%",
      whiteSpace: "pre-wrap"
    },
    ".MuiAlertTitle-root": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      ".notification-time": {
        fontWeight: "normal",
        fontSize: "0.875rem",
        marginLeft: "1em"
      }
    }
  });
});
var NotificationStackItem$1 = NotificationStackItem;

export { NotificationStackItem$1 as default };
